(function ($) {
    $(() => {

        $.debounce = function debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };


        $('.js-number-only').on('input', function (e) {

            var $current_val = $(this).val().replace(/,/g, '.');
            $(this).val($current_val);

            var prev = $(this).attr("data-prev");
            prev = (prev != '') ? prev : '';


            if (Math.round($(this).val() * 100) / 100 != $(this).val()) {
                $(this).val(prev);
            }

            $(this).attr("data-prev", $(this).val())
        })



        $("#calculation--form :input[type='text']").keyup($.debounce(
            function () {
                if ($('.js-current-result').is(":visible")) {
                    $('#calculation--form').submit();
                }
            }, 500));


        $("#calculation--form :input[type='radio']").change(function () {
            if ($('.js-current-result').is(":visible")) {
                $('#calculation--form').submit();
            }
        });


        $('#calculation--form').submit(function (event) {
            event.preventDefault();
            $('.js-current-result').hide();
            $('.js-no-result').show();
            const $this = $(this);



            $this.find('.form-error').text('');

            $this.find('input').removeClass('is-invalid');

            $this.find('.btn[type="submit"]').attr('disabled', true);

            const data = $this.serializeArray();

            $.ajax({
                type: 'post',
                dataType: 'json',
                url: localize.ajaxurl,
                data: {
                    action: 'calculation_form',
                    data
                }
            })
                .done(response => {
                    if (response.status === 'error') {
                        Object.entries(response.errors).forEach(([field, error]) => {
                            $(`#form-error-${field}`).text(error);
                            $(`#${field}`).addClass('is-invalid');
                        });

                        $('html, body').animate({
                            scrollTop: parseInt($("#calculation--form").offset().top - $('.navbar').height())
                        }, 500);
                    }


                    if (response.status === 'success') {

                        $('.js-current-result-inner').html(response.result).promise().done(function (e) {
                            $('.js-no-result').hide();
                            $('.js-current-result').show();

                            $('html, body').animate({
                                scrollTop: parseInt($(".results__wrapper").offset().top - $('.navbar').height())
                            }, 500);
                        });



                        /*  $this.trigger('reset');
                         $('.js-contact-success-modal').show();
 
                         const refresh = `${window.location.protocol}//${window.location.host}${window.location.pathname}?form_submit=true`;
                         window.history.pushState({ path: refresh }, '', refresh); */
                    }
                })
                .always(() => {
                    $this.find('.btn[type="submit"]').attr('disabled', false);
                });
        });


        $('.js-policy').on('change', function (e) {
            $('.js-policy-error').text('');
            $(this).removeClass('is-invalid');
        });

        $(".js-change-type").on('change', function () {
            if (this.checked) {
                $('#vasbeton').prop('checked', true).trigger('change');
            } else {
                $('#konnyuszerkezet').prop('checked', true).trigger('change');
            }
        });


        $('.js-input').on('input', function (e) {
            const $parent = $(this).parents('.form-group');

            $parent.find('.form-error').text('');
            $parent.find('.is-invalid').removeClass('is-invalid');

            // Check if the element has the class 'js-min-number'
            if ($(this).hasClass('js-min-number')) {
                // Get the minimum value from the 'data-min' attribute
                var minValue = parseFloat($(this).data('min'));

                // Check if the current value is less than the minimum value
                if (parseFloat($(this).val()) < minValue) {
                    // Display an error message or handle the error

                    var errorText = localize.translations.minvalue.replace('{minvalue}', minValue);

                    $('#form-error-' + this.id).text(errorText);

                } else {
                    // Clear any error message when the value is valid
                    $('#form-error-' + this.id).text('');
                }
            }

        })

        $('#contact--form').submit(function (event) {
            event.preventDefault();

            const $this = $(this);

            $this.find('.form-error').text('');

            $this.find('input').removeClass('is-invalid');

            $this.find('.btn[type="submit"]').attr('disabled', true);

            const data = $this.serializeArray();
            const calculation_data = $('#calculation--form').serializeArray();


            $.ajax({
                type: 'post',
                dataType: 'json',
                url: localize.ajaxurl,
                data: {
                    action: 'calculation_contact_form',
                    data,
                    calculation_data,
                    becsult: $('.js-becsult').text().trim(),
                    brutto: $('.js-brutto').text().trim()
                }
            })
                .done(response => {
                    if (response.status === 'error') {
                        Object.entries(response.errors).forEach(([field, error]) => {
                            $(`#form-error-${field}`).text(error);
                            $(`#${field}`).addClass('is-invalid');
                        });
                    }

                    if (response.status === 'success') {
                        $this.trigger('reset');
                        $('#calculation--form').trigger('reset');


                        $('.js-current-result-inner').html('').promise().done(function (e) {
                            $('.js-current-result').hide();
                            $('.js-no-result').show();

                            $('html, body').animate({
                                scrollTop: parseInt($(".section__calculator").offset().top - $('.navbar').height())
                            }, 500);
                        });

                        $('.js-contact-success-modal').show();


                    }
                })
                .always(() => {
                    $this.find('.btn[type="submit"]').attr('disabled', false);
                });
        });


        $(document).on('click', '.js-open-result', function (e) {

            if ($(this).hasClass('js-has-gateway')) {
                $('.js-gateway-modal').show();
            } else {
                var $parent = $(this).parent();
                $parent.toggleClass('active');
                $parent.find('.js-result-content').slideToggle();
            }

        });

    });
})(jQuery);
